// extracted by mini-css-extract-plugin
module.exports = {"header":"fatalErrorModal__header6-H","content":"fatalErrorModal__contentUUI","refreshButton":"fatalErrorModal__refreshButton3Gj"};